import { ScreenerFilter } from '@toggle/toggle';

import { useScreenerStore } from '~/views/screener/use-screener-store/useScreenerStore';

export const useScenarioEntityFilters = (): ScreenerFilter[] => {
  const { filterGroups: screenerFilterGroups } = useScreenerStore(state => ({
    filterGroups: state.filterGroups,
  }));

  const screenerMarketFilters = screenerFilterGroups['Market Filters'];
  const screenerKnowledgeGraphFilters =
    screenerFilterGroups['Knowledge Graph Filters'];

  const watchlistFilterKey = 'entity_tag';
  const indexFilterKey = 'market_index';
  const themeExposureKey = 'theme_exposure';

  const watchlistFilter = screenerMarketFilters.allFilters.find(
    filter => filter.key === watchlistFilterKey
  );
  const indexFilter = screenerMarketFilters.allFilters.find(
    filter => filter.key === indexFilterKey
  );
  const themeExposureFilter = screenerKnowledgeGraphFilters.allFilters.find(
    filter => filter.key === themeExposureKey
  );

  return [watchlistFilter, indexFilter, themeExposureFilter].filter(x => !!x);
};
